var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }